import { jsx as c } from "react/jsx-runtime";
import { useEffect as i } from "react";
import { payments as m } from "../../queries/payments/index.js";
import { LoadingOverlay as f } from "../loadingoverlay/index.js";
const P = ({ onPaymentComplete: e, ...r }) => {
  const { refetch: t, isFetching: s } = new m.ChargeCard({ data: r }).ToQuery();
  return i(() => {
    s || (async () => {
      const { data: o, isError: a, error: n } = await t();
      e(a ? { success: !1, error: n } : { success: !0, payment: o });
    })();
  }, []), /* @__PURE__ */ c(f, { open: !0, text: "Processing payment" });
};
export {
  P as ProcessPayment
};
//# sourceMappingURL=ProcessPayment.js.map
